import { useId } from 'react';
import Select from 'react-select';
import styles from './SelectButton.module.css';

export interface ISelectButton {
  /**
   * All options to include in the select button
   */
  selectOptions?: {}[];
  /**
   * What is the current selected option ?
   */
  selectedOption?: {};
  /**
   * What is happening when the use change the selected option ?
   */
  handleOnChange?: any;
  /**
   * Do we want to be able to search among the options ?
   */
  isSearchable?: boolean;
  border?: boolean;
  fontSize?: number;
  fontWeight?: string;
  height?: number;
  width?: number | string;
  /**
   * Which color to apply to the separator and dropdown button?
   */
  color?: string;
  isLoading?: boolean;
  defaultValue?: {};
  backgroundColor?: string;
}

const SelectButton: React.FC<ISelectButton> = ({
  selectOptions,
  selectedOption,
  handleOnChange,
  isSearchable = true,
  border = true,
  fontSize = 14,
  fontWeight = '400',
  height = 40,
  width = '100%',
  color = 'rgb(220, 220, 220)',
  isLoading = false,
  defaultValue,
  backgroundColor = 'white',
}) => {
  const customStyles: {} = {
    option: (styles: {}, state: any) => ({
      ...styles,
      cursor: 'pointer',
      color: state.isSelected ? 'white' : 'black',
      fontSize: 14,
      fontWeight: 400,
    }),
    control: () => ({
      display: 'flex',
      flex: 'flex-wrap',
      alignItems: 'center',
      border: border ? '1px solid rgb(220, 220, 220)' : 'none',
      cursor: 'pointer',
      borderRadius: '5px',
      fontSize: fontSize,
      fontWeight: fontWeight,
      height: height,
      width: width,
      padding: 0,
      backgroundColor: backgroundColor,
    }),
    indicatorSeparator: (base: {}) => ({
      ...base,
      backgroundColor: color,
    }),
    singleValue: (base: {}) => ({
      ...base,
    }),
    dropdownIndicator: (base: {}) => ({
      ...base,
      color: color,
    }),
  };

  return (
    <div className={styles.container}>
      <Select
        options={selectOptions}
        value={selectedOption}
        styles={customStyles}
        onChange={handleOnChange}
        isSearchable={isSearchable}
        isLoading={isLoading}
        instanceId={useId()}
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default SelectButton;
